import { useCallback, useEffect, useState } from 'react';
import { inventarioService } from '../../services/api';
import { btnPrimario, btnSecundario, pesos } from '../../components/ui/estilos';
import { entrada } from '../agenda/campos';

const n = (v: any) => parseFloat(v || 0) || 0;

// Receta de un producto: se usa en Menú › Productos y en Almacén › Inventario (cocina).
export default function RecetaProducto({ producto, say }: { producto: any; say: (m: string) => void }) {
  const [receta, setReceta] = useState<any[]>([]);
  const [insumos, setInsumos] = useState<any[]>([]);
  const [nuevoIng, setNuevoIng] = useState({ insumo_id: '', cantidad: '' });

  const recargar = useCallback(() => inventarioService.getReceta(producto.id).then(r => setReceta(r.data)).catch(() => setReceta([])), [producto.id]);
  useEffect(() => { recargar(); }, [recargar]);
  useEffect(() => { inventarioService.getInsumos().then(r => setInsumos(r.data)).catch(() => {}); }, []);

  // POST /recetas actualiza si el insumo ya estaba en la receta (queda en su historial).
  const poner = async (insumo_id: string, cantidad: number) => {
    if (!insumo_id || !(cantidad > 0)) { say('Elige insumo y una cantidad mayor a 0.'); return false; }
    try { await inventarioService.agregarIngrediente({ producto_id: producto.id, insumo_id, cantidad }); recargar(); return true; }
    catch (e: any) { say(e.response?.data?.error || 'No se pudo guardar la receta.'); return false; }
  };
  const costo = receta.reduce((s, r) => s + n(r.cantidad) * n(r.costo_unitario), 0);

  return <>
    <div style={{ fontSize: 14, color: 'var(--muted)' }}>Insumos que se descuentan del inventario por cada {producto.nombre}.</div>
    {receta.map(r => (
      <div key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', borderRadius: 10, border: '1px solid var(--line)' }}>
        <span style={{ flex: 1, minWidth: 0 }}><b>{r.insumo}</b><span style={{ display: 'block', fontSize: 13, color: 'var(--muted)' }}>{pesos(n(r.cantidad) * n(r.costo_unitario))}</span></span>
        <input type="number" min="0" step="any" defaultValue={r.cantidad} aria-label={`Cantidad de ${r.insumo}`}
          onBlur={e => n(e.target.value) !== n(r.cantidad) && poner(r.insumo_id, n(e.target.value))}
          style={{ ...entrada, width: 90, height: 40, textAlign: 'right' }} />
        <span style={{ fontSize: 14, color: 'var(--muted)', width: 44 }}>{r.unidad}</span>
        <button onClick={() => inventarioService.eliminarIngrediente(r.id).then(recargar).catch(() => say('No se pudo quitar.'))} aria-label={`Quitar ${r.insumo}`} style={{ ...btnSecundario, width: 36, height: 36, padding: 0 }}>✕</button>
      </div>
    ))}
    {!receta.length && <div style={{ color: 'var(--muted)' }}>Sin receta: no descuenta inventario.</div>}
    <div style={{ display: 'flex', gap: 8 }}>
      <select value={nuevoIng.insumo_id} onChange={e => setNuevoIng(x => ({ ...x, insumo_id: e.target.value }))} aria-label="Insumo" style={{ ...entrada, flex: 1, height: 46 }}>
        <option value="">Insumo…</option>
        {insumos.filter(i => !receta.some(r => r.insumo_id === i.id)).map(i => <option key={i.id} value={i.id}>{i.nombre} ({i.unidad})</option>)}
      </select>
      <input type="number" min="0" step="any" placeholder="Cant." value={nuevoIng.cantidad} onChange={e => setNuevoIng(x => ({ ...x, cantidad: e.target.value }))} aria-label="Cantidad" style={{ ...entrada, width: 90, height: 46 }} />
      <button onClick={async () => { if (await poner(nuevoIng.insumo_id, n(nuevoIng.cantidad))) setNuevoIng({ insumo_id: '', cantidad: '' }); }} style={{ ...btnPrimario, height: 46, fontSize: 14 }}>Agregar</button>
    </div>
    {receta.length > 0 && (
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 14px', borderRadius: 10, background: 'var(--well)', fontSize: 15, fontWeight: 700 }}>
        <span>Costo {pesos(costo)}</span>
        <span>Margen {n(producto.precio) ? Math.round((1 - costo / n(producto.precio)) * 100) : 0}%</span>
      </div>
    )}
  </>;
}
